import { apiRequest } from 'api/api-request'
import type { FeedbackOption, StudentFeedbackResponse, SubmitFeedbackResponse, SubmitFeedbackRequest } from './feedbackTypes'

/**
 * Fetches the available student feedback options from the backend
 * @param auth - Authorization token (Bearer token)
 * @returns A promise resolving to the available feedback options
 */
const getStudentFeedback = async (auth: string): Promise<StudentFeedbackResponse | null> => {
    try {
        const baseUrl = process.env.REACT_APP_CORE_COURSE_WEB_URL
        const response = await apiRequest<StudentFeedbackResponse>({
            path: '/bookapi/api/class/studentfeedback/options',
            method: 'GET',
            auth,
            baseUrl
        })
        return response
    } catch (error) {
        console.error(`Failed to fetch student feedback: ${error instanceof Error ? error.message : 'Unknown error'}`)
        return null
    }
}

/**
 * Submit student feedback to the backend
 * @param classId - The class ID
 * @param studentId - The student ID
 * @param auth - Authorization token (Bearer token)
 * @param feedbackType - 0 for negative, 1 for positive
 * @param reason - selected reason/option
 */
const submitStudentFeedback = async (
    classId: string,
    studentId: string,
    auth: string,
    feedbackRequest: SubmitFeedbackRequest
): Promise<SubmitFeedbackResponse | null> => {
    try {
        const baseUrl = process.env.REACT_APP_CORE_COURSE_WEB_URL
        const response = await apiRequest<SubmitFeedbackResponse>({
            path: `/bookapi/api/class/${classId}/students/${studentId}/studentfeedback`,
            method: 'PUT',
            auth,
            payload: feedbackRequest,
            baseUrl
        })

        return response
    } catch (error) {
        console.error(`Failed to fetch student feedback: ${error instanceof Error ? error.message : 'Unknown error'}`)
        return null
    }
}

export type { FeedbackOption }
export { getStudentFeedback, submitStudentFeedback }
